import { escapeHtml } from '../lib/utils.js';

export const STEPS = [
	{ id: 1, label: 'Service' },
	{ id: 2, label: 'Staff' },
	{ id: 3, label: 'Date' },
	{ id: 4, label: 'Details' },
	{ id: 5, label: 'Coupon' },
	{ id: 6, label: 'Payment' },
	{ id: 7, label: 'Done' },
];

const CHECK_SVG =
	'<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 6l2.4 2.4L9.5 3.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

function progressWidth(currentStep) {
	if (STEPS.length <= 1) {
		return 0;
	}
	return ((currentStep - 1) / (STEPS.length - 1)) * 100;
}

function stepRowHtml(currentStep) {
	const items = STEPS.map((s, index) => {
		const done = s.id < currentStep;
		const active = s.id === currentStep;
		const clickable = done;
		const hasConnector = index < STEPS.length - 1;
		let connectorState = '';
		if (hasConnector) {
			if (done) {
				connectorState = ' br-wizard-step--connector-done';
			} else if (active) {
				connectorState = ' br-wizard-step--connector-partial';
			}
		}

		const circleContent = done
			? CHECK_SVG
			: '<span class="br-wizard-step__num">' + s.id + '</span>';

		const inner =
			'<span class="br-wizard-step__circle" aria-hidden="true">' +
			circleContent +
			'</span>' +
			'<span class="br-wizard-step__label">' +
			escapeHtml(s.label) +
			'</span>';

		const cls =
			'br-wizard-step' +
			(done ? ' is-done' : '') +
			(active ? ' is-active' : '') +
			(clickable ? ' is-clickable' : '') +
			(hasConnector ? ' br-wizard-step--has-connector' + connectorState : '');

		if (clickable) {
			return (
				'<li class="' +
				cls +
				'">' +
				'<button type="button" class="br-wizard-step__btn" data-go-step="' +
				s.id +
				'" aria-label="Go back to ' +
				escapeHtml(s.label) +
				'">' +
				inner +
				'</button></li>'
			);
		}

		return (
			'<li class="' +
			cls +
			'" data-step="' +
			s.id +
			'"' +
			(active ? ' aria-current="step"' : '') +
			'>' +
			inner +
			'</li>'
		);
	});

	const pct = progressWidth(currentStep);

	return (
		'<div class="br-wizard-steps__desktop">' +
		'<div class="br-wizard-steps__header">' +
		'<span class="br-wizard-steps__eyebrow">Booking progress</span>' +
		'<span class="br-wizard-steps__counter">Step ' +
		currentStep +
		' of ' +
		STEPS.length +
		'</span></div>' +
		'<div class="br-wizard-steps__track" aria-hidden="true">' +
		'<div class="br-wizard-steps__track-fill" style="width:' +
		pct +
		'%"></div></div>' +
		'<ol class="br-wizard-steps__list">' +
		items.join('') +
		'</ol></div>'
	);
}

export function renderStepIndicator(currentStep) {
	const step = STEPS.find((s) => s.id === currentStep) || STEPS[0];
	const pct = Math.round((currentStep / STEPS.length) * 100);
	const trackPct = progressWidth(currentStep);

	const compact =
		'<div class="br-wizard-steps__compact">' +
		'<div class="br-wizard-steps__header">' +
		'<span class="br-wizard-steps__eyebrow">Booking progress</span>' +
		'<span class="br-wizard-steps__counter">Step ' +
		currentStep +
		' of ' +
		STEPS.length +
		'</span></div>' +
		'<div class="br-wizard-steps__track" aria-hidden="true">' +
		'<div class="br-wizard-steps__track-fill" style="width:' +
		trackPct +
		'%"></div></div>' +
		'<p class="br-wizard-steps__compact-name">' +
		escapeHtml(step.label) +
		'</p>' +
		'<span class="br-wizard-steps__compact-pct">' +
		pct +
		'% complete</span></div>';

	return (
		'<nav class="br-wizard-steps" aria-label="Booking progress">' +
		compact +
		stepRowHtml(currentStep) +
		'</nav>'
	);
}
